"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubMicroAppDealService = void 0;
var user_status_service_1 = require("@common/services/user-status.service");
var SubMicroAppDealService = /** @class */ (function () {
    function SubMicroAppDealService() {
    }
    SubMicroAppDealService.init = function (render) {
        this.renderFn = render;
        // 独立运行时
        if (!window['__POWERED_BY_QIANKUN__']) {
            this.instance = this.renderFn();
        }
    };
    SubMicroAppDealService.bootstrap = function () {
        console.log('project lib bootstraped');
    };
    SubMicroAppDealService.mount = function (props) {
        console.log('project lib mount');
        props.onGlobalStateChange(function (state, prev) {
            // state: 变更后的状态; prev 变更前的状态
            user_status_service_1.UserStatusService.setUserInfo(state.userInfo);
        });
        this.instance = this.renderFn(props);
    };
    SubMicroAppDealService.unmount = function () {
        console.log('project lib unmount');
        this.instance.$destroy();
        this.instance.$el.innerHTML = '';
        this.instance = null;
    };
    SubMicroAppDealService.instance = null;
    SubMicroAppDealService.renderFn = null;
    return SubMicroAppDealService;
}());
exports.SubMicroAppDealService = SubMicroAppDealService;
